import { useEffect, useState } from "react";
import { cn } from "@/lib/utils";


export const LoadingIndicator = () => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    // Create a fluid animation effect for the progress
    const animationInterval = setInterval(() => {
      setProgress(prev => {
        // Reset when it reaches 100%
        if (prev >= 100) return 0;
        // Random increment between 5-15 for natural feel
        return prev + Math.floor(Math.random() * 10) + 5;
      });
    }, 600);

    return () => clearInterval(animationInterval);
  }, []);

  return (
    <div className="flex flex-col items-center w-full py-2">
      {/* Pulse animation */}
      <div className="flex justify-center space-x-3 mb-3">
        {[...Array(3)].map((_, i) => (
          <div 
            key={i} 
            className={cn(
              "h-2 w-2 rounded-full bg-gradient-to-r from-indigo-500 to-blue-500",
              i === 0 ? "animate-[pulse_1.4s_ease-in-out_0s_infinite]" : 
              i === 1 ? "animate-[pulse_1.4s_ease-in-out_0.4s_infinite]" : 
                        "animate-[pulse_1.4s_ease-in-out_0.8s_infinite]"
            )}
          />
        ))}
      </div>
      
      {/* Progress bar */}
      <div className="w-20 h-1 bg-gray-800 rounded-full overflow-hidden">
        <div 
          className="h-full bg-gradient-to-r from-blue-500 via-indigo-500 to-purple-500 rounded-full transition-all duration-300 ease-out"
          style={{ width: `${progress}%` }}
        />
      </div>
    </div>
  );
};
